import Phaser from 'phaser';
import { TextureKey } from '../assets/manifest.js';
import { TUNING } from '../config/tuning.js';
import type { WorldScale } from '../core/WorldScale.js';

const W = TUNING.world;

/** Scrolling sky, city skyline (both parallax) and ground. */
export class Scenery {
  private readonly sky: Phaser.GameObjects.TileSprite;
  private readonly skyline: Phaser.GameObjects.TileSprite;
  private readonly ground: Phaser.GameObjects.TileSprite;

  /** `width` × `height` = the playfield (pixels), `groundY` = the ground surface (see core/playfield.ts) */
  constructor(
    scene: Phaser.Scene,
    ws: WorldScale,
    width: number,
    height: number,
    groundY: number,
    depths: { sky: number; skyline: number; ground: number },
    skyline: TextureKey = TextureKey.Skyline,
  ) {
    const skylineH = ws.px(W.skylineHeight);

    this.sky = scene.add.tileSprite(0, 0, width, height, TextureKey.Sky).setOrigin(0, 0).setDepth(depths.sky);
    this.skyline = scene.add
      .tileSprite(0, groundY, width, skylineH, skyline)
      .setOrigin(0, 1)
      .setDepth(depths.skyline);
    this.ground = scene.add
      .tileSprite(0, groundY, width, height - groundY, TextureKey.Ground)
      .setOrigin(0, 0)
      .setDepth(depths.ground);
  }

  /** Scroll by `dx` pixels. */
  scroll(dx: number): void {
    this.sky.tilePositionX += dx * W.skyParallax;
    this.skyline.tilePositionX += dx * W.skylineParallax;
    this.ground.tilePositionX += dx;
  }
}
